function splitChatKey(key) {
  let text = `${key || ''}`;
  let sep = text.indexOf('::');
  if (sep < 0) {
    return {displayID: text, slot: null};
  }
  return {
    displayID: text.substring(0, sep),
    slot: text.substring(sep + 2),
  };
}

function displayIDFromKey(key) {
  return splitChatKey(key).displayID;
}

function slotFromKey(key) {
  return splitChatKey(key).slot;
}

function roomIdFromKey(key) {
  let slot = slotFromKey(key);
  if (!slot || slot === 'default' || slot === 'lobby') {
    return null;
  }
  return slot;
}

function activeTableSlotsForAccount(onlineAccount) {
  let rawSlots = onlineAccount.table_slots || [];
  if (!Array.isArray(rawSlots) || rawSlots.length === 0) {
    rawSlots = onlineAccount.room_ids || [];
  }
  if (!Array.isArray(rawSlots)) {
    rawSlots = [];
  }

  let slots = [];
  for (let slot of rawSlots) {
    let normalized = normalizeSlot(slot);
    if (normalized === 'default' || normalized === 'lobby') {
      continue;
    }
    if (!slots.includes(normalized)) {
      slots.push(normalized);
    }
  }
  return slots;
}

function chatKeyForMessage(displayID, payload) {
  let roomId = payload && payload.data ? payload.data.roomId : null;
  return roomId ? slotKey(displayID, roomId) : displayID;
}

function makeChatAccount(state, name, slot=null) {
  let displayID = displayIDFromKey(name);
  let accs = state.onlineAccounts;
  if (!(displayID in accs)) {
    return {};
  }

  let onlineAccount = accs[displayID];
  if (onlineAccount.status !== 'in game') {
    // only valid for in game accounts
    return {};
  }

  let key = slotKey(displayID, slot || slotFromKey(name));
  let roomId = roomIdFromKey(key);
  let automationState = state.accounts_automation_state[key] || state.accounts_automation_state[displayID];

  let unread = key in state.numUnread ? state.numUnread[key] : 0;
  let stateKey = roomId ? key : displayID;
  let tableState = state.states[stateKey] || state.states[displayID] || {};
  let res = {
    'app': onlineAccount.app,
    'displayID': onlineAccount.displayID,
    'displayName': onlineAccount.displayID,
    'key': key,
    'slot': slotFromKey(key),
    'roomId': roomId,
    'clubID': onlineAccount.entered_clubID,
    'gameType': (tableState.chat_view || {}).game_type || (onlineAccount.chat_view || {}).game_type,

    'automationState': automationState,

    'unread': unread,

     // old stuff
    'name': key,
    'online_acc': onlineAccount,
  };

  let keys = [
      'gave_warning',
      'warned_again',
      'break',
      'snoozed',
      'priming',
      'buyin_state',
      'operator_dont_want_to_leave',
      'contacting_host',
      'contacting_host_not_available',
      'contacting_host_users',
      'claimed',
      'claimed_user_id',
      'available_bankroll',
      'operator_needs_help',
      'is_typing',
      'asked_to_wait_paused_table_until_ts',

      'tourney_states',

      // tech stuff
      'trainer_version',
  ];

  for (let key of keys) {
    res[key] = onlineAccount[key];
  }

  if (roomId) {
    let byRoomFields = [
      'operator_want_to_leave',
      'operator_dont_want_to_leave',
      'gave_warning',
      'warned_again',
    ];
    for (let field of byRoomFields) {
      let byRoom = onlineAccount[`${field}_by_room`] || {};
      if (byRoom[roomId]) {
        res[field] = byRoom[roomId];
      } else if (res[field] && res[field].room_id && `${res[field].room_id}` !== `${roomId}`) {
        res[field] = null;
      }
    }
  }

  return res;
}

function normalizeSlot(slot) {
  if (slot === undefined || slot === null || slot === '') {
    return 'default';
  }
  return `${slot}`;
}

function slotKey(name, slot) {
  let normalized = normalizeSlot(slot);
  if (normalized === 'default') {
    return name;
  }
  return `${name}::${normalized}`;
}

function botStateSlot(data) {
  let st = data && data.state ? data.state : {};
  return normalizeSlot(data.slot || st.slot || st.room_id);
}


function updateBotState(state, data) {
  if (!data || !data.state || !data.state.room_id) {
    return;
  }

  let slot = botStateSlot(data);
  data.state.slot = slot;
  let key = slotKey(data.displayID, slot);
  state.states[key] = data.state;

  // Keep the legacy displayID key populated for old views that are not slot-aware.
  state.states[data.displayID] = data.state;

  // ! set room queue info by player
  if (data.room_state) {
    state.roomQueue[key] = data.room_state.room_queue;
    if (data.room_state.room_queue) {
      state.roomQueue[key].queue_status = data.room_state.queue_status;
    }
    state.roomQueue[data.displayID] = state.roomQueue[key];
  }
}

export {
  updateBotState,
  makeChatAccount,
  slotKey,
  normalizeSlot,
  splitChatKey,
  displayIDFromKey,
  slotFromKey,
  roomIdFromKey,
  activeTableSlotsForAccount,
  chatKeyForMessage,
};
